import React from 'react';
import '../styles/FloatingButtons.css';

const FloatingButtons = () => {
  const phoneNumber = '+971542921340';
  const whatsappNumber = '971542921340'; // Without + for WhatsApp
  const whatsappMessage = 'Hello%20BookMyGround%2C%20I%20want%20to%20book%20a%20ground';

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`, '_blank');
  };

  return (
    <div className="floating-buttons visible">
      {/* Call Button - Left Side */}
      <button 
        className="floating-btn call-btn"
        onClick={handleCall}
        aria-label="Call Now"
      >
        <div className="btn-content">
          <i className="fas fa-phone-alt"></i>
          <span className="btn-text">Call Now</span>
        </div>
        <div className="btn-ripple"></div>
      </button>

      {/* WhatsApp Button - Right Side */}
      <button 
        className="floating-btn whatsapp-btn"
        onClick={handleWhatsApp}
        aria-label="WhatsApp Us"
      >
        <div className="btn-content">
          <i className="fab fa-whatsapp"></i>
          <span className="btn-text">WhatsApp</span>
        </div>
        <div className="btn-ripple"></div>
      </button>
    </div>
  );
};

export default FloatingButtons;